"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddProduct = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _api = require("../../../../api");
var _getProductBox = require("../../../../api/getProductBox");
var _personalProductListEditContext = require("../../../../contexts/personalProductListEditContext");
var _hooks = require("../../../../hooks");
var _useTranslations = require("../../../../hooks/useTranslations");
var _AddProductError = require("../AddProductError/AddProductError");
var _AddProductSearchInput = require("../AddProductSearchInput/AddProductSearchInput");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AddProduct = ()=>{
    const { open, onClose: onCloseDialog, setProducts, products } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const [errorMessage, setErrorMessage] = (0, _react.useState)();
    const [product, setProduct] = (0, _react.useState)();
    const [inputInvalid, setInputInvalid] = (0, _react.useState)(true);
    const { data: pplConfiguration } = (0, _hooks.usePplConfigurationQuery)();
    const form = (0, _reactHookForm.useForm)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { graphQlNetUrl, staticApiUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet',
        'staticApi'
    ]);
    const { headers } = (0, _presentationHttp.useHeaders)();
    const { language } = (0, _i18n.useTranslationsWithNamespaces)();
    const { tenant } = (0, _environment.useEnvironment)();
    const onClose = (0, _react.useCallback)(()=>{
        onCloseDialog();
        form.reset();
        setProduct(undefined);
        setErrorMessage(undefined);
        setInputInvalid(true);
    }, [
        form,
        onCloseDialog
    ]);
    const addProduct = (0, _react.useCallback)(async (newProduct)=>{
        onClose();
        const isDuplicate = products.find((item)=>{
            if (item.type === 'product') {
                return item.code === newProduct.productCode;
            }
            return false;
        });
        if (isDuplicate) {
            return;
        }
        const productBox = await (0, _getProductBox.getProductBoxData)({
            productCode: newProduct.productCode,
            tenant,
            staticApiUrl,
            language
        });
        if (!productBox) {
            return;
        }
        /* istanbul ignore next */ setProducts((prevProducts)=>[
                ...prevProducts,
                {
                    type: 'product',
                    ...productBox
                }
            ]);
    }, [
        language,
        onClose,
        products,
        setProducts,
        staticApiUrl,
        tenant
    ]);
    const onSubmit = async (formData)=>{
        var _searchedProduct_permission;
        if (product) {
            await addProduct(product);
            return;
        }
        const { product: searchedProduct } = await (0, _api.getProduct)({
            graphQlNetUrl,
            headers,
            productCode: formData.productCode
        });
        if (searchedProduct === null || searchedProduct === void 0 ? void 0 : (_searchedProduct_permission = searchedProduct.permission) === null || _searchedProduct_permission === void 0 ? void 0 : _searchedProduct_permission.canDisplay) {
            var _searchedProduct_concept;
            setErrorMessage(undefined);
            setProduct(searchedProduct);
            var _searchedProduct_concept_name;
            form.setValue('productCode', "".concat(searchedProduct.productCode, " - ").concat((_searchedProduct_concept_name = (_searchedProduct_concept = searchedProduct.concept) === null || _searchedProduct_concept === void 0 ? void 0 : _searchedProduct_concept.name) !== null && _searchedProduct_concept_name !== void 0 ? _searchedProduct_concept_name : ''));
        } else {
            setErrorMessage(translations.sorryMsgText);
            setProduct(undefined);
        }
    };
    const onInputChange = (0, _react.useCallback)((event)=>setInputInvalid(Number.isNaN(Number.parseInt(event.target.value, 10))), []);
    const onInputReset = (0, _react.useCallback)(()=>{
        form.reset();
        setErrorMessage(undefined);
        setProduct(undefined);
        setInputInvalid(true);
    }, [
        form
    ]);
    const header = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Header, {
            variant: "h4",
            component: "h4",
            align: "center",
            children: errorMessage ? translations.sorryMsgTitle : translations.searchDialogName
        }), [
        errorMessage,
        translations.searchDialogName,
        translations.sorryMsgTitle
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
        open: open,
        header: header,
        onClose: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
            ...form,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: form.handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Content, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddProductError.AddProductError, {
                                errorMessage: errorMessage
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddProductSearchInput.AddProductSearchInput, {
                                isError: Boolean(errorMessage),
                                onInputReset: onInputReset,
                                onChange: onInputChange
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SubmitButton, {
                                autoFocus: true,
                                type: "submit",
                                color: "primary",
                                variant: "contained",
                                disabled: inputInvalid,
                                "data-testid": getTestId(_constants.ADD_PRODUCT_DIALOG_SEARCH),
                                "data-search-status": product ? 'add' : 'search',
                                children: product ? translations.addBtn : translations.searchBtn
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Actions, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Link, {
                            variant: "button",
                            href: pplConfiguration === null || pplConfiguration === void 0 ? void 0 : pplConfiguration.homePageUrl,
                            target: "_blank",
                            children: translations.searchDialogLinkName
                        })
                    })
                ]
            })
        })
    });
};
exports.AddProduct = AddProduct;
